import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

import Account from '@/pages/Users/Account';
import Blog from '@/pages/Blog';
import BlogEntry from '@/pages/BlogEntry';
import CapsuleBuilder from '@/pages/Users/CapsuleBuilder';
import Community from '@/pages/Community';
import DemoBlog from '@/pages/DemoBlog';
import Discover from '@/pages/Discover';
import DiscoverCapsules from '@/pages/discover/DiscoverCapsules';
import DiscoverOutfits from '@/pages/discover/DiscoverOutfits';
import Error from '@/pages/Error';
import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import StitchedOutfits from '@/pages/Users/StitchedOutfits';
import Policy from '@/pages/Policy';
import Register from '@/pages/Register';
import SignUp from '@/pages/SignUp';
import ShowCapsule from '@/pages/showCapsule';
import Tailor from '@/pages/Users/Tailor';
import Terms from '@/pages/Terms';
import Test from '@/pages/Test';
import User from '@/pages/User';
import Wardrobe from '@/pages/Users/Wardrobe';
import WardrobeClothes from '@/pages/Users/Wardrobe/WardrobeClothes';
import WardrobeOutfits from '@/pages/Users/Wardrobe/WardrobeOutfits';

import { checkAuth } from './utils/auth';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior,
  routes: [{
    path: '/',
    name: 'Root',
    component: Landing,
    beforeEnter: (to, from, next) => {
      isAuthenticated(next);
    }
  },
  {
    path: '/home',
    name: 'Home',
    redirect: { name: 'DiscoverCapsules'}
  },
  {
    path: '/discover',
    component: Discover,
    children: [
      {
        path: '',
        name: 'DiscoverCapsules',
        component: DiscoverCapsules,
      },
      {
        path: 'outfits',
        name: 'DiscoverOutfits',
        component: DiscoverOutfits,
      }
    ]
  },
  {
    path: '/test',
    name: 'Test',
    component: Test
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/blog/:slug',
    name: 'BlogEntry',
    component: BlogEntry
  },
  {
    path: '/landing',
    name: 'Landing',
    component: Landing
  },
  {
    path: '/community',
    name: 'Community',
    component: Community
  },
  {
    path: '/demo-blog',
    name: 'DemoBlog',
    component: DemoBlog
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Terms
  },
  {
    path: '/policy',
    name: 'Policy',
    component: Policy
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/logout',
    name: 'LogOut',
    redirect: {
      name: 'Root'
    }
  },
  {
    path: '/capsules/:capsuleId',
    name: 'ShowCapsule',
    component: ShowCapsule
  },
  {
    path: '/:username',
    component: User,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      handleAuthorization(isCurrentUser(to.params.username), next);
    },
    children: [
      {
        path: 'stitched-outfits',
        name: 'StitchedOutfits',
        component: StitchedOutfits
      },
      {
        path: 'wardrobe',
        component: Wardrobe,
        children: [
          {
            path: '',
            name: 'WardrobeClothes',
            component: WardrobeClothes
          },
          {
            path: 'outfits',
            name: 'WardrobeOutfits',
            component: WardrobeOutfits
          }
        ]
      },
      {
        path: 'tailor',
        name: 'Tailor',
        component: Tailor
      },
      {
        path: 'tailor/builder/:capsuleId',
        name: 'CapsuleBuilder',
        component: CapsuleBuilder,
        beforeEnter: (to, from, next) => {
          handleAuthorization(isAuthorizedStylist(), next);
        }
      },
      {
        path: 'account',
        name: 'Account',
        component: Account,
      }
    ]
  },
  {
    path: '*',
    name: 'Error',
    component: Error
  }]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    checkAuth(to, from, next);
  } else {
    next();
  }
});

function scrollBehavior(to, from, savedPosition) {
  // Exists when Browser's back/forward pressed
  if (savedPosition) {
    return savedPosition

  // For anchors
  } else if (to.hash) {
    return { selector: to.hash, behavior: 'smooth' }

  // By changing queries we are still in the same component, so "from.path" === "to.path" (new query changes just "to.fullPath", but not "to.path").
  } else if (from.path === to.path) {
    return {}
  }

  // Scroll to top
  return { x: 0, y: 0 }
}

function handleAuthorization(isValid, next) {
  if (isValid) {
    next();
  } else {
    next({ name: 'Root' });
  }
}

function isAuthenticated(next) {
  store.dispatch('checkAuthenticated').then(() => {
    if (store.getters.isAuthenticated) {
      next({ name: 'DiscoverCapsules' });
    } else {
      next();
    }
  });
};

function isAuthorizedStylist() {
  return store.getters.currentUser.role === 'stylist'
};

function isCurrentUser(username) {
  const currentUsername = store.getters.currentUser.username;
  return currentUsername.localeCompare(username, 'en', { sensitivity: 'accent' }) === 0;
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js